export const MAX_LENGTH = 5000;
const COMPOSER_MAX_HEIGHT = 200;

export function autoGrow(el: HTMLTextAreaElement | null): void {
  if (!el) return;
  el.style.height = 'auto';
  el.style.height = `${Math.min(el.scrollHeight, COMPOSER_MAX_HEIGHT)}px`;
}
